<div class="gameHeader">
  <!-- 'leftbtn' or 'rightbtn', which will come it depends on condition -->
  <button class="back leftbtn" *ngIf="backButtonStatus">
    <a (click)="loadBack()">
      <svg class="svgicon">
        <use xlink:href="assets/images/sprite-sheet.svg#icon-leftarrow"></use>
      </svg>
    </a>
  </button>
  <div class="pageIndicator">
    <div class="title"><span class="gamename">{{'common.' + gameCode | translate}}</span><span
        class="ticketNum">{{ticketNumber}}</span>
    </div>
  </div>
  <!-- <button class="close rightbtn" (click)="loadBack()">
    <div class="title">x</div>
  </button> -->
</div>
<div class="viewTicketWrap">
  <div class="sectionWrapper" *ngIf="showTicket">
    <div class="tkt-section" *ngFor="let draws of ticketResponse?.drawWinList; let drawIndex = index;">
      <div class="section lt">
        <div class="subSection tkt-baseinfo">
          <div class="elementWrap ele-tkt">
            <div class="label">{{'sle.draw_time' | translate}}.</div>
            <div class="element">
              <div class="value">{{ draws?.drawDateTime | date: 'MMM dd, yyyy - HH:mm' }} </div>
            </div>
          </div>
          <div class="elementWrap ele-drawnum">
            <div class="label">{{'sle.draw_no' | translate}}</div>
            <div class="element">
              <div class="value">{{ draws?.drawId }}</div>
            </div>
          </div>
        </div>
        <div class="subSection tkt-result">
          <div class="title" *ngIf="gameCode != 'LuckySix'">{{'sle.draw_result' | translate}}</div>
          <div class="title" *ngIf="gameCode == 'LuckySix'">
            <ng-container *ngIf="!checkDrawAddons(draws?.winningMultiplierInfo)">
              {{'sle.draw_result' | translate}}
            </ng-container>
            <ng-container *ngIf="checkDrawAddons(draws?.winningMultiplierInfo)">
              <div class="lt d-flex">{{'sle.draw_result' | translate}} <div class="iconSymbol flag flag-{{clientCode}}">
                </div>
              </div>
              <div class="rt">
                <span class="label text-capitalize">{{'sle.draw_result' | translate}}:</span>
                <span class="value">{{draws?.winningMultiplierInfo?.value}}x</span>
              </div>
            </ng-container>
          </div>
          <div class="resultWrap" *ngIf="panelType == 1">
            <!-- 'resultDetail' or 'resultMsg' -->
            <div *ngIf="draws.winResult != 'RESULT AWAITED' && draws.drawStatusForticket != 'CLAIM_HOLD'"
              class="resultDetail" [ngClass]="gameName.replace(' ', '-') | lowercase">
              <ng-container *ngIf="gameCode != 'powerball' && gameCode != 'SixByFortyTwoBonusBall' && gameCode != 'FiveByFortyNineLottoWeekly'">
                <ul class="ballList">
                  <li *ngFor="let num of drawWinNumber(draws?.winResult)">
                    <div *ngIf="gameCode != 'OneByTwelve'"
                      class="ballWrap active ball-{{numberArray[num]?.color == '' ? 'orange' : numberArray[num]?.color}}"
                      [ngClass]="{'cloverBg': gameCode == 'LuckySix' && checkClover(draws, num)}">
                      <div class="ball">
                        <span class="value">{{num}}</span>
                      </div>
                    </div>
                  </li>
                </ul>
              </ng-container>
              <ng-container *ngIf="gameCode == 'SixByFortyTwoBonusBall' || gameCode == 'FiveByFortyNineLottoWeekly'">
                <ng-container *ngVar="drawWinNumber2(draws?.winResult) as resultVar">
                  <ul class="ballList">
                    <li *ngFor="let num of resultVar[0]">
                      <div
                        class="ballWrap active ball-{{numberArray[num]?.color == '' ? 'orange' : numberArray[num]?.color}}">
                        <div class="ball">
                          <span class="value">{{num}}</span>
                        </div>
                      </div>
                    </li>
                    <li class="plusSign">+</li>
                    <li *ngFor="let num of resultVar[1]">
                      <div
                        class="ballWrap active ball-{{numberArray2[num]?.color == '' ? 'orange' : numberArray2[num]?.color}}">
                        <div class="ball">
                          <span class="value">{{num}}</span>
                        </div>
                      </div>
                    </li>
                  </ul>
                </ng-container>
              </ng-container>
              <ng-container *ngIf="gameCode == 'powerball'">
                <ng-container *ngVar="drawWinNumber2(draws?.powerBallWinningResult?.Direct6) as resultVar">
                  <ul class="ballList">
                    <!-- <li class="label">PowerBall</li> -->
                    <li *ngFor="let num of resultVar[0]">
                      <div
                        class="ballWrap active ball-{{numberArray[num]?.color == '' ? 'orange' : numberArray[num]?.color}}">
                        <div class="ball">
                          <span class="value">{{num}}</span>
                        </div>
                      </div>
                    </li>
                    <li class="plusSign">+</li>
                    <li *ngFor="let num of resultVar[1]">
                      <div
                        class="ballWrap active ball-{{numberArray2[num]?.color == '' ? 'orange' : numberArray2[num]?.color}}">
                        <div class="ball">
                          <span class="value">{{num}}</span>
                        </div>
                      </div>
                    </li>
                  </ul>
                </ng-container>
                <ng-container *ngVar="drawWinNumber2(draws?.powerBallWinningResult?.Direct6Plus) as resultVar">
                  <ul class="ballList">
                    <!-- <li class="label">PowerBall Plus</li> -->
                    <li *ngFor="let num of resultVar[0]">
                      <div
                        class="ballWrap active ball-{{numberArray[num]?.color == '' ? 'orange' : numberArray[num]?.color}}">
                        <div class="ball">
                          <span class="value">{{num}}</span>
                        </div>
                      </div>
                    </li>
                    <li class="plusSign">+</li>
                    <li *ngFor="let num of resultVar[1]">
                      <div
                        class="ballWrap active ball-{{numberArray2[num]?.color == '' ? 'orange' : numberArray2[num]?.color}}">
                        <div class="ball">
                          <span class="value">{{num}}</span>
                        </div>
                      </div>
                    </li>
                  </ul>
                </ng-container>
              </ng-container>

            </div>
            <div *ngIf="draws.winResult == 'RESULT AWAITED' && draws.drawStatusForticket != 'CLAIM_HOLD'"
              class="resultMsg">
              {{'sle.result_will_be_declared_on' | translate}}
              <span class="dateTime">
                {{ draws?.drawDateTime | date: 'MMM dd, yyyy - HH:mm' }}
              </span>
            </div>
            <div *ngIf="draws.drawStatusForticket == 'CLAIM_HOLD'" class="resultMsg">
              {{'dge.result_hold' | translate}}
            </div>
          </div>
          <div class="resultWrap" *ngIf="panelType == 3">
            <!-- 'resultDetail' or 'resultMsg' -->
            <div *ngIf="draws?.winResult != 'RESULT AWAITED' && draws?.drawStatusForticket != 'CLAIM_HOLD'"
              class="resultDetail" [ngClass]="gameName.replace(' ', '-') | lowercase">
              <ul class="ballList">
                <li *ngFor="let num of drawWinNumber(draws?.winResult)">
                  <div class="itemSymWrap active" *ngIf="gameCode == 'OneByTwelve'">
                    <div class="itemSym icon-{{iconMapping[num]}}">
                      <svg class="svgicon">
                        <use [attr.xlink:href]="'assets/images/fortune-sprite.svg#icon-'+iconMapping[num]">
                        </use>
                      </svg>
                    </div>
                    <div class="label">{{'dge.'+iconMapping[num] | translate}}</div>
                  </div>
                  <div *ngIf="gameCode == 'Zerotonine'" class="ballWrap active ball-{{numberArray[num]?.color == '' ? 'orange' : numberArray[num]?.color}}">
                    <div class="ball">
                      <span class="value">{{num}}</span>
                    </div>
                  </div>
                </li>
              </ul>
            </div>
            <div *ngIf="draws?.winResult == 'RESULT AWAITED' && draws?.drawStatusForticket != 'CLAIM_HOLD'"
              class="resultMsg">
              {{'sle.result_will_be_declared_on' | translate}}
              <span class="dateTime">
                {{ draws?.drawDateTime | date: 'MMM dd, yyyy - HH:mm' }}
              </span>
            </div>
            <div *ngIf="draws.drawStatusForticket == 'CLAIM_HOLD'" class="resultMsg">
              {{'dge.result_hold' | translate}}
            </div>
          </div>
          <div class="resultWrap" *ngIf="panelType == 2">
            <!-- 'resultDetail' or 'resultMsg' -->
            <div class="resultDetail gameThaiLotto" [ngClass]="{'game2dmyanmar': gameCode == 'TwoDMYANMAAR'}"
              *ngIf="draws.winResult != 'RESULT AWAITED' && draws.drawStatusForticket != 'CLAIM_HOLD' && gameCode != 'BichoRapido'" >
              <div class="lastResultInnerWrap" *ngIf="gameCode != 'TwoDMYANMAAR' && gameCode != 'BingoSeventyFive3'">
                <div class="lt-resultWrap" >
                  <div class="blk">
                    <div class="up-box">
                      <div class="label">{{'dge.1st_prz' | translate}}</div>
                      <!-- <div class="cat" innerHTML="{{'dge.Category1' | translate}}"> -->
                      <!-- 1<sup>st</sup> {{'dge.cat' | translate}} -->
                      <!-- </div> -->
                    </div>
                    <div class="dw-box">
                      <div class="value">{{getLastDrawResult(0)}}{{getLastDrawResult(1)}}</div>
                    </div>
                  </div>
                  <div class="blk">
                    <div class="up-box">
                      <div class="label">{{'dge.1st_3' | translate}}</div>
                      <!-- <div class="cat" innerHTML="{{'dge.Category2' | translate}}"> -->
                      <!-- 2<sup>nd</sup> {{'dge.cat' | translate}} -->
                      <!-- </div> -->
                    </div>
                    <div class="dw-box">
                      <div class="value">{{getLastDrawResult(2)}}/{{getLastDrawResult(3)}}</div>
                    </div>
                  </div>
                  <div class="blk">
                    <div class="up-box">
                      <div class="label">{{'dge.lst_3' | translate}}</div>
                      <!-- <div class="cat" innerHTML="{{'dge.Category3' | translate}}"> -->
                      <!-- 3<sup>rd</sup> {{'dge.cat' | translate}} -->
                      <!-- </div> -->
                    </div>
                    <div class="dw-box">
                      <div class="value">{{getLastDrawResult(4)}}/{{getLastDrawResult(5)}}</div>
                    </div>
                  </div>
                  <div class="blk">
                    <div class="up-box">
                      <div class="label">{{'dge.2_dig' | translate}}</div>
                      <!-- <div class="cat" innerHTML="{{'dge.Category4' | translate}}"> -->
                      <!-- 4<sup>th</sup> {{'dge.cat' | translate}} -->
                      <!-- </div> -->
                    </div>
                    <div class="dw-box">
                      <div class="value">{{getLastDrawResult(6)}}</div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="lastResultInnerWrap" *ngIf="gameCode == 'TwoDMYANMAAR'">
                <div class="lt-resultWrap">
                    <div class="blk">
                        <div class="up-box">
                            <div class="label">{{((draws?.drawDateTime | date:'a') == 'AM' ? 'dge.am' : 'dge.pm') | translate}}</div>
                        </div>
                        <div class="dw-box">
                            <div class="value">{{getLastDrawResult(0)}}</div>
                        </div>
                    </div>
                </div>
              </div>
              <div class="lastResultInnerWrap" *ngIf="gameCode == 'BingoSeventyFive3'">
              <div class="resultDetail bingoBallsSection"
              *ngIf="draws.winResult != 'RESULT AWAITED' && draws.drawStatusForticket != 'CLAIM_HOLD'"
              [ngClass]="gameName.replace(' ', '-') | lowercase">
              <ul class="balls">
                <li class="color{{checkResultMachineBall(num)?.machineBall}}"
                  *ngFor="let num of drawWinNumber(draws?.winResult)">
                  <div class="ball">
                    <div class="value"><span class="symbol">{{checkResultMachineBall(num)?.str}}</span><span
                        class="num">{{num}}</span></div>
                  </div>
                </li>
              </ul>
            </div>
            </div>
            </div>
            <div class="resultDetail game-zooLotto" *ngIf="gameCode == 'BichoRapido' && draws?.winResult != 'RESULT AWAITED' && draws?.drawStatusForticket != 'CLAIM_HOLD'">
              <div class="animal-res-block-wrap">
                  <ng-container *ngFor="let item of drawWinNumber1(draws?.winResult); let l = index;">
                    <div class="animal-res-block arb-{{l+1}}">
                        <div class="img-wrap" *ngIf="item?.name && item?.number">
                            <img src="./assets/images/animals/{{item?.number.toString().length == 2 ? item?.number: '0'+ item?.number}}{{item?.name}}.jpg" alt="{{item?.name}}">
                            <div class="num-wrap">
                                <div class="num">{{item?.numArray[0]}}</div>
                                <div class="num">{{item?.numArray[1]}}</div>
                                <div class="num">{{item?.numArray[2]}}</div>
                                <div class="num">{{item?.numArray[3]}}</div>
                            </div>
                        </div>
                        <div class="desc-wrap">
                            <div class="ani-detail">
                                <div class="num">{{item?.number.toString().length == 2 ? item?.number: '0'+ item?.number}}</div>
                                <div class="title">{{item?.name}}</div>
                            </div>
                            <div class="realWrap">
                                <div class="realNum">{{item?.joinNumber[0]}}</div>
                                <div class="realNum">{{item?.joinNumber[1]}}</div>
                                <div class="realNum">{{item?.joinNumber[2]}}</div>
                                <div class="realNum">{{item?.joinNumber[3]}}</div>
                            </div>
                        </div>
                    </div>
                  </ng-container>
                  <!-- <div class="animal-res-block arb-2">
                      <div class="img-wrap">
                          <img src="./assets/images/animals/04Borboleta.jpg" alt="Borboleta">
                          <div class="num-wrap">
                              <div class="num">13</div>
                              <div class="num">14</div>
                              <div class="num">15</div>
                              <div class="num">16</div>
                          </div>
                      </div>
                      <div class="desc-wrap">
                          <div class="ani-detail">
                              <div class="num">04</div>
                              <div class="title">Borboleta</div>
                          </div>
                          <div class="realWrap">
                              <div class="realNum">5</div>
                              <div class="realNum">9</div>
                              <div class="realNum">1</div>
                              <div class="realNum">6</div>
                          </div>
                      </div>
                  </div> -->
              </div>
          </div>
            <div class="resultMsg"
              *ngIf="draws.winResult == 'RESULT AWAITED' && draws.drawStatusForticket != 'CLAIM_HOLD'">
              {{'sle.result_will_be_declared_on' | translate}}
              <span class="dateTime">
                {{ draws?.drawDateTime | date: 'MMM dd, yyyy - HH:mm' }}
              </span>
            </div>
            <div *ngIf="draws.drawStatusForticket == 'CLAIM_HOLD'" class="resultMsg">
              {{'dge.result_hold' | translate}}
            </div>
          </div>
        </div>
      </div>
      <div class="section rt">
        <div class="tkt-betPlayedWrap">
          <div class="title">
            <div class="lt tktNum" *ngIf="gameCode != 'BingoSeventyFive3'">{{'dge.your_bet' | translate}}</div>
            <div class="lt tktNum" *ngIf="gameCode == 'BingoSeventyFive3'">
              <span class="label">{{'dge.ticket_number' | translate}}</span>
              <span class="num">{{ticketNumber}}</span>
            </div>
            <div class="rt betVal">
              <span class="label">{{'dge.bet' | translate}}</span>
              <!-- <div class="amountWrap" innerHTML="{{draws?.betAmountPaid | custCurrency}}"></div> -->
              <div class="amountWrap" *ngIf="clientCode != 'guinee'" innerHTML="{{draws?.betAmountPaid | custCurrency}}"></div>
              <div class="amountWrap" *ngIf="clientCode == 'guinee'" innerHTML="{{userInfo?.currDisplay | currencySymbol}} {{numberWithSpaces(draws?.betAmountPaid)}}"></div>
            </div>
          </div>
          <div class="playedBingoCardsWrap" *ngIf="gameCode == 'BingoSeventyFive3'">
            <div class="gameBingo">
              <div class="cardWrapper {{cardClass}}">
                <div class="cardGroup" *ngFor="let panel of draws?.panelWinList;let pIndex = index;">
                  <div class="cardWrap">
                    <span class="bingoIconWrap" [ngClass]="{'show': false}">
                      <img src="assets/images/bingo.svg">
                    </span>
                    <div class="bingoWinPriceWrap"
                      *ngIf="panel?.winningAmt != 0 && draws?.drawStatusForticket == 'CLAIM_ALLOW'">
                      <div class="bingoWinPrice" innerHTML="{{panel?.winningAmt | custCurrency}}"></div>
                    </div>
                    <div class="card">
                      <div class="cardTitle">
                        <span>B</span>
                        <span>I</span>
                        <span>N</span>
                        <span>G</span>
                        <span>0</span>
                      </div>
                      <div class="cardNumWrap">
                        <ul>
                          <ng-container *ngFor="let first of panel?.pickedData; let j = index">
                            <li class="num" *ngFor="let second of first; let k = index" [ngClass]="{
                                'Free': second == 'X',
                                'empty': second == '_',
                                'winOut': false,
                                'highlight': draws?.winResult?.includes(second) && draws.drawStatusForticket != 'CLAIM_HOLD',
                                'win': ticketMatchData[0]?.data[drawIndex][pIndex]?.includes(second)
                              }">
                              <span *ngIf="second == 'X'">
                                <svg class="svgicon starIcon">
                                  <use xlink:href="assets/images/sprite-sheet.svg#icon-star">
                                  </use>
                                </svg>
                              </span>
                              <span *ngIf="second != 'X'">{{(second !=  '_' ? second : '')}}</span>
                            </li>
                          </ng-container>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="playedRowWrap" *ngIf="panelType == 1">
            <div class="item-row" *ngFor="let panel of draws?.panelWinList;let pIndex = index;">
              <div class="col1">
                <ng-container *ngIf="gameCode != 'powerball' && gameCode != 'SixByFortyTwoBonusBall' && gameCode != 'FiveByFortyNineLottoWeekly'  && gameCode != 'BingoSeventyFive3'">
                  <div class="selection"
                    *ngIf="panel.pickType != 'Banker' && panel.pickType != 'Banker1AgainstAll' && betData[panel.playType]?.winMode == 'MAIN'">
                    <div class="ballBox" *ngIf="gameCode != 'OneByTwelve'">
                      <div
                        class="ballWrap ball-{{numberArray[pickedNo]?.color == '' ? 'orange' : numberArray[pickedNo]?.color}} {{checkAcHOMain(pickedNo, draws)}}"
                        *ngFor="let pickedNo of panel.pickedData; let k = index;"
                        [ngClass]="{'cloverBg': gameCode == 'LuckySix' && checkClover(draws, pickedNo)}">
                        {{pickedNo}}
                      </div>
                    </div>
                  </div>
                  <div class="selection" *ngIf="panel.pickType == 'Banker' || panel.pickType == 'Banker1AgainstAll'">
                    <div class="txt">UL-</div>
                    <div class="ballBox">
                      <div class="ballWrap ball-{{numberArray[pickedNo]?.color}} {{checkAcHOMain(pickedNo, draws)}}"
                        *ngFor="let pickedNo of panel.pickedData[0]; let k = index;">
                        {{pickedNo}}
                      </div>
                    </div>
                  </div>
                  <div class="selection" *ngIf="panel.pickType == 'Banker' || panel.pickType == 'Banker1AgainstAll'">
                    <div class="txt">LL-</div>
                    <div class="ballBox">
                      <div class="ballWrap ball-{{numberArray[pickedNo]?.color}} {{checkAcHOMain(pickedNo, draws)}}"
                        *ngFor="let pickedNo of panel.pickedData[1]; let k = index;">
                        {{pickedNo}}
                      </div>
                    </div>
                  </div>
                </ng-container>
                <ng-container *ngIf="gameCode == 'powerball' || gameCode == 'FiveByFortyNineLottoWeekly'">
                  <div class="selection selwrap-6by42" *ngIf="betData[panel.playType]?.winMode == 'MAIN'">
                    <div class="ballBox">
                      <div
                        class="ballWrap ball-{{numberArray[pickedNo]?.color == '' ? 'orange' : numberArray[pickedNo]?.color}} {{checkAcHOPowerball(pickedNo, draws, 0)}}"
                        *ngFor="let pickedNo of panel.pickedData[0]; let k = index;">
                        {{pickedNo}}
                      </div>
                    </div>
                    <span class="plusSign">+</span>
                    <div class="ballBox">
                      <div
                        class="ballWrap ball-{{numberArray2[pickedNo]?.color == '' ? 'orange' : numberArray2[pickedNo]?.color}} {{checkAcHOPowerball(pickedNo, draws, 1)}}"
                        *ngFor="let pickedNo of panel.pickedData[1]; let k = index;">
                        {{pickedNo}}
                      </div>
                    </div>
                  </div>
                </ng-container>
                <ng-container *ngIf="gameCode == 'SixByFortyTwoBonusBall'">
                  <div class="selection selwrap-6by42" *ngIf="betData[panel.playType]?.winMode == 'MAIN'">
                    <div class="ballBox">
                      <div
                        class="ballWrap ball-{{numberArray[pickedNo]?.color == '' ? 'orange' : numberArray[pickedNo]?.color}} {{checkAcHOPowerball(pickedNo, draws, 0)}}"
                        *ngFor="let pickedNo of panel.pickedData[0]; let k = index;">
                        {{pickedNo}}
                      </div>
                    </div>
                    <!-- <span class="plusSign">+</span>
                    <div class="ballBox">
                      <div
                        class="ballWrap ball-{{numberArray2[pickedNo]?.color == '' ? 'orange' : numberArray2[pickedNo]?.color}} {{checkAcHOPowerball(pickedNo, draws, 1)}}"
                        *ngFor="let pickedNo of panel.pickedData[1]; let k = index;">
                        {{pickedNo}}
                      </div>
                    </div> -->
                  </div>
                </ng-container>
                <div class="selection" *ngIf="betData[panel.playType]?.winMode != 'MAIN'">
                  <div class="valuebox {{checkAcHOSide(panel.playType, panel.pickType, draws)}}"
                    *ngIf="betData[panel.playType]?.winMode == 'COLOR'">
                    <div
                      class="colorDot ball-{{betData[panel.playType]?.pickTypeData.pickType[panel.pickType].range[0].pickValue.split('<')[1] | lowercase}}">
                    </div>
                    {{'dge.'+getSideBetPickName(betData[panel.playType]?.pickTypeData.pickType[panel.pickType].range[0].pickValue.split('<')[1]) | translate}}
                  </div>
                  <div class="valuebox {{checkAcHOSide(panel.playType, panel.pickType, draws)}}"
                    *ngIf="betData[panel.playType]?.winMode == 'SUM'">
                    {{betData[panel.playType]?.pickTypeData.pickType[panel.pickType].range[0].pickValue.split('<')[0] == 0 ? '&lt; ' + betData[panel.playType]?.pickTypeData.pickType[panel.pickType].range[0].pickValue.split('<')[2] : '&gt;
                      ' + betData[panel.playType]?.pickTypeData.pickType[panel.pickType].range[0].pickValue.split('<')[0]  | titlecase}}
                  </div>
                  <div class="valuebox {{checkAcHOSide(panel.playType, panel.pickType, draws)}}"
                    *ngIf="betData[panel.playType]?.winMode == 'ODD_EVEN'">
                    {{'dge.'+getSideBetPickName(betData[panel.playType]?.pickTypeData.pickType[panel.pickType].range[0].pickValue.split('<')[1]) | translate}}
                  </div>
                  <div class="valuebox {{checkAcHOSide(panel.playType, panel.pickType, draws)}}"
                    *ngIf="betData[panel.playType]?.winMode == 'PATTERN'">
                    {{'dge.'+getSideBetPickName(betData[panel.playType]?.pickTypeData.pickType[panel.pickType].range[0].pickValue) | translate}}
                  </div>
                </div>
                <div class="detail small" *ngIf="gameCode != 'OneByTwelve' && gameCode != 'powerball' && gameCode != 'SixByFortyTwoBonusBall' && gameCode != 'FiveByFortyNineLottoWeekly'">
                  <span>
                    {{(betData[panel.playType]?.winMode == 'MAIN' ? 'dge.mainbet' : 'dge.sidebet') | translate}}
                  </span>
                  <span class="separator">|</span>
                  <span>
                    {{'dge.'+betData[panel.playType]?.betDispName | translate}}
                  </span>
                  <span class="separator">|</span>
                  <span>
                    {{'dge.'+getPickName(betData[panel.playType]?.pickTypeData?.pickType[panel.pickType]?.code, betData[panel.playType]?.pickTypeData?.pickType[panel.pickType]?.name, panel?.quickPickType) | translate}}
                  </span>
                  <ng-container *ngIf="betData[panel.playType]?.winMode == 'MAIN'">
                    <span class="separator">-</span>
                    <span>
                      {{numberOfLines(drawIndex, pIndex, gameCode)}}
                      {{(numberOfLines(drawIndex, pIndex, gameCode) > 1 ? 'dge.lines' : 'dge.line') | translate}}
                    </span>
                  </ng-container>
                </div>
                <div class="detail small" *ngIf="gameCode == 'powerball' || gameCode == 'SixByFortyTwoBonusBall' || gameCode == 'FiveByFortyNineLottoWeekly'">
                  <span>
                    {{'dge.'+betData[panel.playType]?.betDispName | translate}}
                  </span>
                  <span class="separator">|</span>
                  <span>
                    {{'dge.'+getPickName(betData[panel.playType]?.pickTypeData?.pickType[panel.pickType]?.code, betData[panel.playType]?.pickTypeData?.pickType[panel.pickType]?.name, panel?.quickPickType) | translate}}
                  </span>
                </div>
              </div>
              <div class="col2">
                <!-- <div class="amountWrap" innerHTML="{{panel?.lineAmountTicketCurr | custCurrency}}"></div> -->
                <div class="amountWrap" *ngIf="clientCode != 'guinee'" innerHTML="{{panel?.lineAmountTicketCurr | custCurrency}}"></div>
                <div class="amountWrap no-wrap"  *ngIf="clientCode == 'guinee'" innerHTML="{{userInfo?.currDisplay | currencySymbol}} {{numberWithSpaces(panel?.lineAmountTicketCurr)}}"></div>
              </div>
              <div class="col4" *ngIf="panel?.winningAmt != 0 && draws?.drawStatusForticket == 'CLAIM_ALLOW'">
                <div class="amountWrap winning">
                  <span class="small">{{'dge.won' | translate}}</span>
                  <!-- <div class="currencywrap" innerHTML="{{panel?.winningAmt | custCurrency}}"></div> -->
                  <div class="currencywrap" *ngIf="clientCode != 'guinee'" innerHTML="{{panel?.winningAmt | custCurrency}}"></div>
                  <div class="currencywrap"  *ngIf="clientCode == 'guinee'" innerHTML="{{userInfo?.currDisplay | currencySymbol}} {{numberWithSpaces(panel?.winningAmt)}}"></div>
                </div>
              </div>
            </div>
          </div>
          <div class="playedRowWrap" *ngIf="panelType == 3">
            <div class="item-row" *ngFor="let panel of draws?.panelWinList;let pIndex = index;">
              <div class="col1">
                <div class="item"
                  *ngIf="panel.pickType != 'Banker' && panel.pickType != 'Banker1AgainstAll' && betData[panel.playType]?.winMode == 'MAIN'">
                  <div class="selection" *ngIf="gameCode == 'OneByTwelve'">
                    <div class="itemSymWrap {{checkAcHOMain(pickedNo, draws)}}"
                      *ngFor="let pickedNo of panel.pickedData; let k = index;">
                      <div class="itemSym icon-{{iconMapping[pickedNo]}}">
                        <svg class="svgicon">
                          <use [attr.xlink:href]="'assets/images/fortune-sprite.svg#icon-'+iconMapping[pickedNo]">
                          </use>
                        </svg>
                      </div>
                      <div class="label">{{'dge.'+iconMapping[pickedNo] | translate}}</div>
                    </div>
                  </div>
                </div>
                <div class="selection" *ngIf="gameCode == 'Zerotonine'">
                  <!-- <div class="ballBox no-wrap">
                    <div class="ballWrap x-auto ball-{{numberArray[pickedNo]?.color == '' ? 'orange' : numberArray[pickedNo]?.color}} {{checkAcHOMain(pickedNo, draws)}}"
                      *ngFor="let pickedNo of panel.pickedData; let k = index;">
                      {{getMappedData(pickedNo)}}
                    </div>
                  </div> -->
                  <!-- <div class="ballBox">
                    <div class="ballWrap ball-{{numberArray[pickedNo]?.color}} {{checkAcHOMain(pickedNo, draws)}}"
                      *ngFor="let pickedNo of panel.pickedData[0]; let k = index;">
                      {{pickedNo}}
                    </div>
                  </div> -->
                  <div class="valuebox {{checkAcHOMain(pickedNo, draws)}}"
                  *ngFor="let pickedNo of panel.pickedData; let k = index;"> {{getMappedData(pickedNo)}} </div>
                </div>
                <div class="detail small" *ngIf="gameCode != 'Zerotonine' && gameCode != 'OneByTwelve'">
                  <span>
                    {{(betData[panel.playType]?.winMode == 'MAIN' ? 'dge.mainbet' : 'dge.sidebet') | translate}}
                  </span>
                  <span class="separator">|</span>
                  <span>
                    {{'dge.'+betData[panel.playType]?.betDispName | translate}}
                  </span>
                  <span class="separator">|</span>
                  <span>
                    {{'dge.'+getPickName(betData[panel.playType]?.pickTypeData?.pickType[panel.pickType]?.code, betData[panel.playType]?.pickTypeData?.pickType[panel.pickType]?.name, panel?.quickPickType) | translate}}
                  </span>
                  <ng-container *ngIf="betData[panel.playType]?.winMode == 'MAIN'">
                    <span class="separator">-</span>
                    <span>
                      {{numberOfLines(drawIndex, pIndex, gameCode)}}
                      {{(numberOfLines(drawIndex, pIndex, gameCode) > 1 ? 'dge.lines' : 'dge.line') | translate}}
                    </span>
                  </ng-container>
                </div>
              </div>
              <div class="col2">
                <div class="amountWrap" innerHTML="{{panel?.lineAmountTicketCurr | custCurrency}}"></div>
              </div>
              <div class="col4" *ngIf="panel?.winningAmt != 0 && draws?.drawStatusForticket == 'CLAIM_ALLOW'">
                <div class="amountWrap winning">
                  <span class="small">{{'dge.won' | translate}}</span>
                  <div class="currencywrap" innerHTML="{{panel?.winningAmt | custCurrency}}"></div>
                </div>
              </div>
            </div>
          </div>
          <ng-container *ngIf="gameCode != 'BingoSeventyFive3'">
          <div class="playedRowWrap" *ngIf="panelType == 2">
            <div class="item-row" *ngFor="let panel of draws?.panelWinList;let pIndex = index;">
              <div class="col1" *ngIf="gameCode != 'TwoDMYANMAAR' && gameCode != 'BichoRapido'  && gameCode != 'BingoSeventyFive3'">
                <div class="selection">
                  <div [ngClass]="{'withvaluepays': gameCode == 'ThaiLottery' && panel?.winningMultiplier}">
                    <div class="valuebox {{checkAcHOMainThai(panel, draws)}}">
                      {{panel?.pickedData?.join('')}}
                    </div>
                    <div class="paysbox" *ngIf="gameCode == 'ThaiLottery' && panel?.winningMultiplier">
                      x{{panel?.winningMultiplier}} {{'dge.pays' | translate | lowercase}}
                    </div>
                  </div>
                </div>
                <div class="detail small">
                  <span>
                    {{((betData[panel?.playType]?.betGroup == "3Digit") ? 'dge.3_digit' : ((betData[panel?.playType]?.betGroup == "2Digit") ? 'dge.2_digit' : ((betData[panel?.playType]?.betGroup == "1Digit") ? 'dge.1_digit' : ''))) | translate}}
                  </span>
                  <span class="separator">:</span>
                  <span
                    innerHTML="{{'dge.GD-'+getBetName(betData[panel?.playType]?.betDispName)+'-'+betData[panel?.playType]?.pickTypeData?.pickType[panel?.pickType]?.name | translate}}"></span>
                  <!-- <span>
                    {{'dge.'+getBetName(betData[panel?.playType]?.betDispName) | translate}}
                  </span> -->
                  <!-- <span class="separator">-</span> -->
                  <!-- <span innerHTML="{{'dge.' + betData[panel?.playType]?.pickTypeData?.pickType[panel?.pickType]?.name | translate}}"></span> -->
                  <!-- <ng-container
                    *ngFor="let catElemt of betData[panel?.playType]?.pickTypeData?.pickType[panel?.pickType]?.name.split('+'); let u = index;">
                    {{u > 0 ? ' + ' : ''}}{{ catElemt | slice:-1}}<sup>{{ catElemt | slice:-1 | ordinal}}</sup>
                  </ng-container> {{'dge.cat' | translate}} -->
                </div>
              </div>
              <div class="col1" *ngIf="gameCode == 'TwoDMYANMAAR'">
                <div class="selection">
                  <div class="valuebox {{checkAcHO2DMyanmar(panel, draws)}}">
                    {{panel?.pickedData?.join('')}}</div>
                </div>
                <div class="detail small">
                  <span>
                    {{'dge.'+getBetName(betData[panel?.playType]?.betDispName) | translate}}
                  </span>
                  <span class="separator">-</span>
                  <span>
                    {{'dge.'+get2DPickName(betData[panel.playType]?.pickTypeData?.pickType[panel.pickType]?.code,
                        betData[panel.playType]?.pickTypeData?.pickType[panel.pickType]?.name,
                        [panel?.pickedData?.join('')]) | translate}}
                  </span>
                </div>
              </div>
              <div class="col1" *ngIf="gameCode == 'BichoRapido'">
                <div class="selection">
                  <div class="valuebox" *ngIf="panel?.playType == 'Centena1to5' || panel?.playType == 'Centena'">x{{panel?.pickedData?.join('')}}</div>
                  <div class="valuebox" *ngIf="panel?.playType != 'Centena1to5' && panel?.playType != 'Centena' && panel?.playType != 'TurnoDeGroupo' && panel?.playType != 'Groupo'">{{panel?.pickedData?.join('')}}</div>
                  <div class="animalSelectBox" *ngIf="panel?.playType == 'TurnoDeGroupo' || panel?.playType == 'Groupo'">
                    <ng-container *ngFor="let item of panel?.pickedData">
                      <div class="title">
                          <div class="num">{{item}}</div>
                          <div class="name">{{getAnimalDetails(item).name}}</div>
                      </div>
                      <div class="img-num-wrap">
                          <div class="img">
                              <img src="./assets/images/animals/{{item}}{{getAnimalDetails(item).name}}.jpg" alt="{{getAnimalDetails(item).name}}">
                          </div>
                          <div class="core-nums">
                              <div class="num">{{getAnimalDetails(item).numArray[0]}}</div>
                              <div class="num">{{getAnimalDetails(item).numArray[1]}}</div>
                              <div class="num">{{getAnimalDetails(item).numArray[2]}}</div>
                              <div class="num">{{getAnimalDetails(item).numArray[3]}}</div>
                          </div>
                      </div>
                    </ng-container>
                  </div>
                </div>
                <div class="detail small">{{'dge.'+ betData[panel?.playType]?.betDispName | translate}}</div>
              </div>
              <div class="col2" *ngIf="gameCode != 'BingoSeventyFive3'">
                <div class="amountWrap" innerHTML="{{panel?.lineAmountTicketCurr | custCurrency}}"></div>
              </div>
              <div class="col4">
                <div class="col4" *ngIf="panel?.winningAmt != 0 && draws?.drawStatusForticket == 'CLAIM_ALLOW'">
                  <div class="amountWrap winning">
                    <span class="small">{{'dge.won' | translate}}</span>
                    <div class="currencywrap" innerHTML="{{panel?.winningAmt | custCurrency}}"></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </ng-container>
          <div
            *ngIf="draws?.winResult != 'RESULT AWAITED' && draws.winningAmt > 0 && draws?.drawStatusForticket == 'CLAIM_ALLOW' && draws?.panelWinList[0]?.status != 'CANCELLED'"
            class="resultMsgWrap win">
            <p>
              {{'sle.you_have_won' | translate}}
              <span class="amountWrap" *ngIf="clientCode !='guinee'" innerHTML="{{draws?.winningAmt | custCurrency}}"></span>
              <span class="amountWrap" *ngIf="clientCode =='guinee'" innerHTML="{{userInfo?.currDisplay | currencySymbol}} {{numberWithSpaces(draws?.winningAmt)}}"></span>
            </p>
          </div>
          <div
            *ngIf="draws?.winResult != 'RESULT AWAITED' && draws.winningAmt <= 0 && draws?.drawStatusForticket == 'CLAIM_ALLOW' && draws?.panelWinList[0]?.status != 'CANCELLED'"
            class="resultMsgWrap lose">
            <p>{{'sle.better_luck_next_time' | translate}}</p>
          </div>
          <div *ngIf="draws?.panelWinList[0]?.status == 'CANCELLED'" class="resultMsgWrap cancel">
            <p>{{'sle.ticket_cancelled' | translate}}</p>
          </div>
        </div>
      </div>
    </div>
    <div class="buttonWrap buyAgain" (click)="buyAgain()" *ngIf="gameCode !='BingoSeventyFive3'">
      <button>{{'dge.buy_same_again' | translate}}</button>
    </div>
  </div>
</div>

